import { fromZonedTime } from 'date-fns-tz';

// helpers
import {
  Duration,
  pad,
  getColorFromDuration,
  ZONE_BY_COUNTRY,
  Props,
  msToDuration,
} from './helpers/durationUtils';

export const FinalDurationTask = ({ startAt, updatedAt, country }: Props) => {
  const zone = ZONE_BY_COUNTRY[country];
  const startDate = fromZonedTime(startAt, zone);
  const updatedDate = fromZonedTime(updatedAt || '', zone);

  const startMs = startDate.getTime();
  const endMs = updatedDate.getTime();

  const diffMs = Math.max(endMs - startMs, 0);
  const duration: Duration = msToDuration(diffMs);
  const color = getColorFromDuration(diffMs);

  const timeString = `${pad(duration.hours)}:${pad(duration.minutes)}:${pad(
    duration.seconds
  )}`;

  return (
    <div style={{ color, fontWeight: 'bold' }}>
      {duration.days > 0 ? `${duration.days}d ` : ''}
      {timeString}
    </div>
  );
};
